export default function(performances) {
    var now = (new Date()).getTime();
    return performances.filter(function(performance) {
        var dtWithoutTimezone = performance.perf_date.slice(0, -6);
        var dt = (new Date(dtWithoutTimezone)).getTime();
        return dt >= now;
    });
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/common/filterPastPerformances.js